import React, { useEffect, useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconValidationValid } from '@adc/parallax-icons';
import { ApiStatus } from 'Enums';
import { useApiError, useCaregiver, useToast } from 'Hooks';
import { Link, Main, RichText, Spinner, TitleActionBar } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { cutString } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { logout } from 'Utilities/session';
import { store } from 'Utilities/store';
const LLUPendingConnectionDetails = ({ data: { caregiverInvitation } }) => {
    const [footerLoading, setFooterLoading] = useState(false);
    const [mainLoading, setMainLoading] = useState(true);
    const { showToast } = useToast();
    const { showApiErrorModal } = useApiError();
    const { resendCaregiverInvite, removeCaregiverInvitation, showRemoveInvitationConfirmationModal, } = useCaregiver();
    useEffect(() => {
        if (!caregiverInvitation) {
            mediator.publish('router:navigate', '/connections');
        }
        setMainLoading(false);
    }, [caregiverInvitation]);
    const onResendInvitation = async () => {
        try {
            setFooterLoading(true);
            await resendCaregiverInvite(caregiverInvitation);
            showToast({
                message: i18n.t('Connections.modals.invitationSentToast.body'),
                'aria-label': i18n.t('Connections.modals.invitationSentToast.body'),
                icon: React.createElement(IconValidationValid, { color: "$support.positive.default" }),
            });
        }
        catch (err) {
            const error = err;
            if (error.status === ApiStatus.UNAUTHORIZED) {
                logout();
                return;
            }
            if (error.status === ApiStatus.TOO_MANY_REQUESTS) {
                store.dispatch({
                    type: SHOW_MODAL,
                    modalProps: {
                        details: (React.createElement(RichText, { text: i18n.t('Connections.modals.invitationLimitDialog.body'), testID: "Connections.modals.invitationLimitDialog.body" })),
                        testID: 'InvitationLimitDialog',
                    },
                });
                return;
            }
            showApiErrorModal();
        }
        finally {
            setFooterLoading(false);
        }
    };
    const onRemoveInvitation = async () => {
        showRemoveInvitationConfirmationModal(async () => {
            try {
                setFooterLoading(true);
                await removeCaregiverInvitation(caregiverInvitation);
                showToast({
                    message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
                    'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved'),
                });
                mediator.publish('router:navigate', '/connections');
            }
            catch (err) {
                const error = err;
                if (error.status === ApiStatus.UNAUTHORIZED) {
                    logout();
                    return;
                }
                showApiErrorModal();
            }
            finally {
                setFooterLoading(false);
            }
        });
    };
    if (mainLoading) {
        return React.createElement(Spinner, null);
    }
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "PendingConnection", title: `${cutString(caregiverInvitation.firstName, 10)} ${cutString(caregiverInvitation.lastName, 10)}`, closeBtn: true, onBack: () => mediator.publish('router:navigate', '/connections') }),
        React.createElement(Stack, { margin: "$4", padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$-1" },
            React.createElement(Text, { testID: "PendingConnection.title", color: "$text.100", fontWeight: "$h3.strong", fontSize: "$h3.strong" }, i18n.t('Connections.content.pendingConnection.primaryText')),
            React.createElement(Text, { testID: "PendingConnection.bodyText", marginTop: "$2", color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default" }, i18n.t('Connections.content.pendingConnection.bodyText')),
            React.createElement(Text, { testID: "PendingConnection.email-label", marginTop: "$8", color: "$text.60", fontWeight: "$bodySmall.default", fontSize: "$bodySmall.default" }, i18n.t('Connections.content.pendingConnection.secondaryText')),
            React.createElement(Text, { testID: "PendingConnection.email", color: "$text.100", fontWeight: "$bodyBase.medium", fontSize: "$bodyBase.medium" }, caregiverInvitation.email),
            React.createElement(Divider, { marginVertical: "$4", borderColor: "$neutral.40" }),
            footerLoading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center" },
                React.createElement(LoadingSpinner, null))) : (React.createElement(VStack, null,
                React.createElement(Link, { testID: "PendingConnection.resendInvitation-btn", onPress: onResendInvitation, style: { marginBottom: 32 } }, i18n.t('Connections.content.pendingConnection.links.resendInvitation.label')),
                React.createElement(Link, { testID: "PendingConnection.remove-btn", onPress: onRemoveInvitation, textColor: "$support.danger.default" }, i18n.t('Global.microcopy.common.removeCap')))))));
};
export default LLUPendingConnectionDetails;
